// Transport only: the caller (`BulkLogService`) owns buffering, timers and retry.
import { Injectable, Type, inject } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { ClassviewBulkLogApi } from './classview-bulk-log-api.service';
import { LegacyBulkLogApi } from './legacy-bulk-log-api.service';
import type { BulkLogBatch } from './bulk-log.model';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    inject(
      (environment.useLegacyBackend
        ? LegacyBulkLogApi
        : ClassviewBulkLogApi) as Type<BulkLogApiService>,
    ),
})
export abstract class BulkLogApiService {
  /** POST the batch; reject on transport failure so the caller can re-buffer and retry. */
  abstract flush(batch: BulkLogBatch): Promise<void>;

  /**
   * Unload-safe send (visibilitychange:hidden / pagehide). Fire-and-forget, no retry.
   * Returns false when the unload-safe channel is unavailable so the caller can fall
   * back to a normal `flush`.
   */
  abstract flushUnloadSafe(batch: BulkLogBatch): boolean;
}
